<template>
  <v-container fluid>
    <v-card flat dense>
      <v-card-title dense>
        <v-toolbar color="warning">
          <v-toolbar-title>Alertas</v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-list dense two-line>
          <v-list-item v-for="item in lista" :key="item.id">
            <v-list-item-icon>
              <v-icon color="primary">warning</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-html="item.comentarios"></v-list-item-title>
              <v-list-item-subtitle
                >Cargado por {{ item.responsable }} el
                {{
                  item.fecha | dateParse() | dateFormat('DD/MM/YY')
                }}</v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                icon
                @click="deleteItem(item)"
                v-if="item.responsable != 'sistemas'"
              >
                <v-icon color="grey lighten-1">delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <template v-if="$store.state.debugModeOn">
          Debug Info:
          <p></p>

          Model: {{ model }}
          <p></p>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http } from '@/axios';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      lista: [],
    };
  },
  created() {
    this.lista = this.Lista;
  },
  props: {
    Lista: Array,
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async deleteItem(item) {
      if (confirm('¿Confirma la baja de la alerta?')) {
        try {
          var result = await http.post(
            'gestion/deletealerta',
            JSON.stringify({ id: item.id })
          );
          this.alertSuccess('La alerta ha sido dada de Baja');

          const index = this.lista.indexOf(item);
          if (index > -1) {
            this.lista.splice(index, 1);
          }
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
  },
};
</script>
